import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async createContact(context, id) {
      const response = await http.post(`customer/${id}/daktela`)

      return response
    },
    async searchDaktelaActivities(context, { id, params }) {
      const response = await http.get(
        `customer/${id}/daktela/activities/${requestUrlFunction(params)}`
      )

      return response
    },
  },
}
